import * as React from "react";

export const IconWarning = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="8" fill="white" />
    <g clipPath="url(#clip0_31578_33287)">
      <path
        d="M9.16797 12.4998H10.8346V14.1665H9.16797V12.4998ZM9.16797 5.83317H10.8346V10.8332H9.16797V5.83317ZM9.99297 1.6665C5.39297 1.6665 1.66797 5.39984 1.66797 9.99984C1.66797 14.5998 5.39297 18.3332 9.99297 18.3332C14.6013 18.3332 18.3346 14.5998 18.3346 9.99984C18.3346 5.39984 14.6013 1.6665 9.99297 1.6665ZM10.0013 16.6665C6.31797 16.6665 3.33464 13.6832 3.33464 9.99984C3.33464 6.3165 6.31797 3.33317 10.0013 3.33317C13.6846 3.33317 16.668 6.3165 16.668 9.99984C16.668 13.6832 13.6846 16.6665 10.0013 16.6665Z"
        fill="#EC7126"
      />
    </g>
    <defs>
      <clipPath id="clip0_31578_33287">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
